import { IBuilderComponent } from "@faire/web/builder/registerBuilderComponents/types";
import { TypographyProps } from "@faire/web/slate/Typography";

export interface IAdditionalProps {
  textContent: string;
}

export const BuilderConfig: IBuilderComponent<
  TypographyProps,
  IAdditionalProps
> = {
  name: "Typography",
  relativePath: "./Typography.ts",
  propDefinition: {
    name: "TypographyProps",
    path: "./Types.ts",
  },
  transformations: {
    children: (props) => props.textContent,
    "data-test-id": null,
  },
  defaultValues: {
    textContent: "Enter some text...",
  },
  localizedFields: ["textContent"],
};
